const defaultLayerOption = { enableAltitude: true }

export const LAYERS = [
  "venue",
  "level",
  "unit",
  "fixture",
  "kiosk",
  "opening",
  "section",
  "section.marker",
  "anchor",
  "route.path",
  "amenity",
  "hilight",
  "route.marker",
  "occupant",
  "user_location",
  "last_user_location",
  "featured_marker",
  "decoration",
]

export const DEFAULT_BASEMAP = {
  enabled: true,
  url_template: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  subdomains: [],
  opacity: 0.6,
  css_filter: "grayscale(1)",
  max_available_zoom: 19,
}

export const ORIGIN_MARKER_ID = "master-origin-marker"
export const DESTINATION_MARKER_ID = "master-destination-marker"
export const USER_LOCATION_ELEMENT_ID = "user_location"
export const LAST_USER_LOCATION_ELEMENT_ID_PREFIX = "last_user_location-"

export const LAYER_OPTIONS = {
  venue: { ...defaultLayerOption },
  level: { ...defaultLayerOption },
  fixture: { ...defaultLayerOption },
  unit: { ...defaultLayerOption },
  kiosk: { ...defaultLayerOption },
  opening: { ...defaultLayerOption },
  section: { ...defaultLayerOption },
  "section.marker": { ...defaultLayerOption, zIndex: 10 },
  anchor: { ...defaultLayerOption },
  amenity: { ...defaultLayerOption },
  "route.path": { ...defaultLayerOption },
  hilight: { ...defaultLayerOption, zIndex: 99 },
  "route.marker": { ...defaultLayerOption, zIndex: 99 },
  occupant: { ...defaultLayerOption, zIndex: 10 },
  user_location: { ...defaultLayerOption, zIndex: 99 },
}

export const DEFAULT_SET_HIGHLIGHT_2DELEMENT_IDS_OPTIONS = {
  symbolSet: null,
  defaultMarker: false,
}
